import 'flowbite';
import {__, trans, trans_choice} from './modules/translations.js';
import ColorConverter from "./color-converter.js";
import axios from 'axios';
import '../../vendor/masmerise/livewire-toaster/resources/js';

window.axios = axios;
window.__ = __;
window.trans = trans;
window.trans_choice = trans_choice;

if (!('ColorConverter' in window)) {
    window.ColorConverter = ColorConverter;
}
